import React, { createContext, useContext, ReactNode } from 'react';
import Lenis from 'lenis';

const LenisContext = createContext<React.RefObject<Lenis | null> | null>(null);

export function LenisProvider({
  lenisRef,
  children,
}: {
  lenisRef: React.RefObject<Lenis | null>;
  children: ReactNode;
}) {
  return (
    <LenisContext.Provider value={lenisRef}>
      {children}
    </LenisContext.Provider>
  );
}

export function useLenisRef() {
  return useContext(LenisContext);
}
